import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/christmas/2024/Index.vue')
const Rewards = () => import('../activity/christmas/2024/Rewards.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/christmas/2024',
  name: 'activity_christmas_2024',
  component: Index,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '集卡换圣诞好礼',
  },
}

export const rewardsRoute: RouteConfig = {
  path: '/activity/christmas/2024/rewards',
  name: 'activity_christmas_2024_rewards',
  component: Rewards,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '我的礼品',
  },
}

export default [indexRoute, rewardsRoute]
